import React from 'react';

import { BudgetCurrencyInput } from 'src/components/oneCorp/features/MealCredit/common/formFields/CurrencyInput/BudgetCurrencyInput';

export interface AllowanceAmountCurrencyInputProps {
  name: string;
  id: string;
}

export function AllowanceAmountCurrencyInput({
  name,
  id,
}: AllowanceAmountCurrencyInputProps): JSX.Element {
  return (
    <BudgetCurrencyInput
      id={id}
      name={name}
      label="Allowance amount for people"
    />
  );
}
